import { Component, OnInit, OnDestroy, Input, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AppConstant } from 'src/app/utilities/app.constants';

declare var $: any;
import { firstBy } from 'thenby';
import { FilterService } from 'src/app/services/filter.service';
import * as xlsx from 'xlsx';
import jsPDF from 'jspdf';
import  'jspdf-autotable';
import { Subscription } from 'rxjs';
import { CustomDialogService } from '../../../../../shared/custom-dialog.service';
import { DatePipe } from '@angular/common';
import { AppSpinnerService } from 'src/app/services/app-spinner.service';
import { CrewDataService } from 'src/app/services/crew-data.service';


@Component({
  selector: 'app-crews-ratings-list',
  templateUrl: './crews-ratings-list.component.html',
  styleUrls: ['./crews-ratings-list.component.scss']
})
export class CrewsRatingsListComponent implements OnInit, OnChanges {
  @ViewChild('analyticstable', { static: false }) analyticstable: ElementRef;
  @Input() ratings;
  page = 0;
  pageSize = 25;
  collectionSize = 0;
  csvratings = [];
  tableData = [];
  initialFilterByReports = [];
  reportFilter = false;
  initialFilterByShips = [];
  shipFilter = false;
  subscription: Subscription;
  mailSubscription: Subscription;
  head = [['S. No.', 'Name', 'Crew ID', 'Rank', 'Nationality', 'Age', 'No. Of Reports', 'No. Of Ships', 'Average Rating']]
  
  constructor(
    private router: Router,
    private readonly analyticsService: AnalyticsService,
    private filterService: FilterService,
    private customDialogService: CustomDialogService,
    public datepipe: DatePipe,
    public crewService: CrewDataService,
    public appSpinner: AppSpinnerService) { }

  ngOnInit() {
    this.collectionSize = this.ratings ? this.ratings.length : 0;;
    this.subscription = this.filterService.csvSubject.subscribe(csvParent => {
      console.log("csvParent0", csvParent);
      if (csvParent === "analytics") {
        this.downloadCSV();
      } else if (csvParent === "analyticsPDF") {
        this.downloadPDF();
      }
    });
    this.mailSubscription = this.filterService.emailSubject.subscribe(emailValue => {
      if (emailValue == 'AnalyticsEmail') {
        this.openMail()
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.mailSubscription) {
      this.mailSubscription.unsubscribe();
    }
  }

  downloadCSV() {
    this.csvratings = [];
    let index = 0;
    this.csvratings = [];
    this.ratings.forEach(rating => {
      let avgSafetyRating = rating.averageRating == 0 ? '-' : parseFloat(rating.averageRating).toFixed(2);
      index++;
      let robject = {
        SNo: index,
        Name: rating.userInfo.firstName + ' ' + rating.userInfo.anotherName,
        CrewId: rating.userInfo.crewId,
        Rank: rating.userInfo.rank,
        Nationality: rating.userInfo.nationality,
        Age: rating.userInfo.age,
        NoOfReports: rating.noOfReports,
        NoOfShips: rating.uniqueVessel.length,
        avgSafetyRating
      }
      this.csvratings.push(robject);
    });
    const ws: xlsx.WorkSheet =
      xlsx.utils.json_to_sheet(this.csvratings);
    //xlsx.utils.table_to_sheet(this.analyticstable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'SafetyRatingsSummary.xlsx');
  }

  downloadPDF() {
    this.tableData = [];
    let index = 0;
    this.ratings.forEach(rating => {
      index++;
      let avgSafetyRating = rating.averageRating == 0 ? '-' : parseFloat(rating.averageRating).toFixed(2);
      let robject = [
        index,
        rating.userInfo.firstName + ' ' + rating.userInfo.anotherName,
        rating.userInfo.crewId,
        rating.userInfo.rank,
        rating.userInfo.nationality,
        rating.userInfo.age,
        rating.noOfReports,
        rating.uniqueVessel.length,
        avgSafetyRating
      ]
      this.tableData.push(robject);
      // console.log('this.tableData', this.tableData);
    });
    let doc = new jsPDF('p', 'mm', 'a4')
    var report_name = 'Crew List';
    doc.autoTable( {
      head: this.head,
      headStyles: {
        halign: 'left'
      },
      styles: {
        halign: 'center',
      },
      columnStyles: {
        1: {halign: 'left'},
        2: {halign: 'left'},
        3: {halign: 'left'}
      },
      margin: { top: 35, left: 5, right: 5 ,bottom: 50},
      body: this.tableData,
      didParseCell: (data) => {
        if (data.section === 'head') {
          data.cell.styles.textColor = 'black'
        }
        data.cell.styles.lineWidth = 0.3;
        data.cell.styles.fillColor = '#ffffff'
        data.cell.styles.lineColor = '#E8E8E8'

      },
    })
    doc.setFontSize(13);
    this.addHeaderAndFooter(doc, report_name);
    this.filterService.addRatingDescription(doc);        //method for adding ratings description on PDF
    doc.save('Crew-List.pdf');
  }

  addHeaderAndFooter(pdfObject, report_name) {
		var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    const todayDate = new Date();
    const date = this.datepipe.transform(todayDate, 'dd/MM/yyyy');
		for (var i = 1; i < pdf_pages.length; i++) {
			// We are telling our pdfObject that we are now working on this page
      pdfObject.setPage(i);
      pdfObject.setFontType('unbold');
      pdfObject.text(date, 175, 270);
      pdfObject.setFontType('bold');
      if(i==1) {
        pdfObject.text(report_name,95,30);
        }
      pdfObject.text('Downloaded on Date:', 132, 270);
      pdfObject.text('Analytics', 175, 15);              //Feature name
			pdfObject.text(AppConstant.HEADER_TEXT, 22, 15);
			pdfObject.addImage(AppConstant.IMG_HEADER, 'png', 5, 7, 15, 15);
			pdfObject.addImage(AppConstant.IMG_FOOTER, 'png', 5, 280, 60, 15);
			pdfObject.text('Page ' + i + '/' + number_of_pages,
				pdfObject.internal.pageSize.getWidth() - 30, pdfObject.internal.pageSize.getHeight() - 10);
		}
	}

  ngOnChanges() {
    this.collectionSize = this.ratings? this.ratings.length : 0;
    if (this.ratings) {
      this.ratings.sort(firstBy('averageRating', -1).thenBy((a: any, b: any) => {
        if (a.userInfo && b.userInfo) {
          return a.userInfo.rankOrder - b.userInfo.rankOrder;
        } else {
          return 0;
        }
      }).thenBy((a: any, b: any) => {
        if (a.userInfo && b.userInfo) {
          if (a.userInfo.firstName > b.userInfo.firstName) {
            return 1;
          } else if (a.userInfo.firstName < b.userInfo.firstName) {
            return -1;
          } else {
            return 0;
          }
  
          // return a.userInfo.firstName - b.userInfo.firstName;
        } else {
          return 0;
        }
      }));
      console.log('all rating list', this.ratings);
    }
    
  }

  filterByReports() {
    this.initialFilterByReports = this.ratings;
    if (this.reportFilter == false) {
      this.ratings = this.initialFilterByReports.sort((a, b) => a.noOfReports - b.noOfReports);
      this.reportFilter = true;
    }
    else {
      this.ratings = this.initialFilterByReports.sort((a, b) => b.noOfReports - a.noOfReports);
      this.reportFilter = false;
    }

  }

  filterByShips() {
    this.initialFilterByShips = this.ratings;
    if (this.shipFilter == false) {
      this.ratings = this.initialFilterByShips.sort((a, b) => a.uniqueVessel.length - b.uniqueVessel.length);
      this.shipFilter = true;
    }
    else {
      this.ratings = this.initialFilterByShips.sort((a, b) => b.uniqueVessel.length - a.uniqueVessel.length);
      this.shipFilter = false;
    }
  }

  openCrewRatings(rating: any) {
    this.analyticsService.setSelectedRating(rating);
    this.router.navigate([`analytics/crew-ratings-detail/${rating._id}`]);
  }

  ratingScale() {
    this.customDialogService.showRatingScaleDialogue(AppConstant.Rating_Scale,'ratingScale');
  }

 
  openMail() {
    this.tableData = [];
    let index = 0;
    this.ratings.forEach(rating => {
      index++;
      let avgSafetyRating = rating.averageRating == 0 ? '-' : parseFloat(rating.averageRating).toFixed(2);
      let robject = [
        index,
        rating.userInfo.firstName + ' ' + rating.userInfo.anotherName,
        rating.userInfo.crewId,
        rating.userInfo.rank,
        rating.userInfo.nationality,
        rating.userInfo.age,
        rating.noOfReports,
        rating.uniqueVessel.length,
        avgSafetyRating
      ]
      this.tableData.push(robject);
    });
    let doc = new jsPDF('p', 'mm', 'a4')
    var report_name = 'Crew List';
    doc.autoTable({
      head: this.head,
      headStyles: {
        halign: 'left'
      },
      styles: {
        halign: 'center',
      },
      columnStyles: {
        1: {halign: 'left'},
        2: {halign: 'left'},
        3: {halign: 'left'}
      },
      margin: { top: 50, left: 5, right: 5 ,bottom: 50},
      body: this.tableData,
      didParseCell: (data) => {
        if (data.section === 'head') {
          data.cell.styles.textColor = 'black'
        }
        data.cell.styles.lineWidth = 0.3;
        data.cell.styles.fillColor = '#ffffff'
        data.cell.styles.lineColor = '#E8E8E8'

      },
    })
    doc.setFontSize(13);
    this.addHeaderAndFooter(doc, report_name);
    this.filterService.addRatingDescription(doc);        //method for adding ratings description on PDF
    const pdfBase64 = doc.output('datauristring');
    this.customDialogService.showDialog('Do you want to email the pdf file of this screen?','yes').subscribe(actionType => {
      console.log('actionType ',actionType);
      if(actionType === 'yes'){
        this.appSpinner.show();
        this.crewService.sendEmailToUser('Analytics_CrewList.pdf', pdfBase64).subscribe((data: any)=>{
          if(data){
            console.log('sucessfull ',data);
            this.appSpinner.hide();
            this.customDialogService.showDialog(data.message, 'dismiss');
          }
          
        }); 
      }
      else{

      }
    })
  }
}
